import {useContext} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {SheetEditContext} from '../SheetContexts'

const AssignmentEntityModalHeader = () => {
  const {closeEntityModal} = useContext(SheetEditContext)

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Vincular con ficha colaborador</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeEntityModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {AssignmentEntityModalHeader}
